import React from 'react';
import { Button } from 'components/ui/button';
import { Plus, Calendar } from 'lucide-react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  showAction?: boolean;
  variant?: 'default' | 'campaign';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  showAction = false,
  variant = 'default'
}) => {
  const getDefaultIcon = () => {
    if (variant === 'campaign') {
      return <Calendar className="h-12 w-12" />;
    }
    
    return (
      <svg fill="currentColor" viewBox="0 0 20 20">
        <path 
          fillRule="evenodd" 
          d="M4 3a2 2 0 00-2 2v1.586l8 8 8-8V5a2 2 0 00-2-2H4zm5.707 8.707L18 3.414V16a2 2 0 01-2 2H4a2 2 0 01-2-2V3.414l8.293 8.293a1 1 0 001.414 0z" 
          clipRule="evenodd" 
        />
      </svg>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="mx-auto max-w-md">
        <div className="mx-auto h-12 w-12 text-gray-400 mb-4">
          {icon || getDefaultIcon()}
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {title}
        </h3>
        <p className="text-gray-500 mb-6">
          {description}
        </p>
        {showAction && actionLabel && onAction && (
          <Button onClick={onAction}>
            <Plus className="h-4 w-4 mr-2" />
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
